export const DataHooks = { checkIcon: 'checkIcon' };
